import { gql } from '@apollo/client';

export const EXISTIERT_PERSONALNUMMER_IN_ANDEREM_STANDORT = gql(`
  query rotationsplan_existiertPersonalnummerInAnderemStandort($standortId: String!, $mitarbeiterId: String!) {
   mitarbeiter_existiertPersonalnummerInAnderemStandort (mitarbeiterId: $mitarbeiterId, standortId: $standortId){
    existiertPersonalnummer
   }
  }
`);
